import { Select } from "antd";
import { STORE_REQUISITION_LIST } from "apiServices/API_ENDPOINTS";
import { getData } from "apiServices/common";
import debounce from "lodash/debounce";
import { useCallback, useEffect, useMemo, useState } from "react";

const { Option } = Select;

const StoreRequisitionNoSelect = ({
  movementType,
  value,
  onChange,
  placeholder = "Search requisition no.",
  size = "small",
  disabled = false,
  allowClear = true,
}) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchRequisitions = useCallback(
    async (search = "") => {
      if (!movementType) {
        setOptions([]);
        return;
      }

      setLoading(true);
      const response = await getData(`${STORE_REQUISITION_LIST}?page=1`, false, {
        per_page: 50,
        movement_type: movementType,
        ...(search ? { requisition_no: search } : {}),
      });

      if (response?.data?.code === 200) {
        setOptions(response?.data?.data?.data || []);
      } else {
        setOptions([]);
      }

      setLoading(false);
    },
    [movementType],
  );

  const debouncedSearch = useMemo(
    () =>
      debounce((searchValue) => {
        fetchRequisitions(searchValue);
      }, 400),
    [fetchRequisitions],
  );

  useEffect(() => {
    fetchRequisitions();
    return () => debouncedSearch.cancel();
  }, [fetchRequisitions, debouncedSearch]);

  const displayOptions = useMemo(() => {
    if (value && !options.some((item) => item.requisition_no === value)) {
      return [{ id: `selected-${value}`, requisition_no: value }, ...options];
    }
    return options;
  }, [options, value]);

  return (
    <Select
      showSearch
      allowClear={allowClear}
      placeholder={placeholder}
      optionFilterProp="children"
      filterOption={false}
      size={size}
      disabled={disabled || !movementType}
      value={value}
      onChange={onChange}
      loading={loading}
      onSearch={debouncedSearch}
      onClear={() => fetchRequisitions()}
    >
      {displayOptions.map((item) => (
        <Option key={item.id} value={item.requisition_no}>
          {item.requisition_no}
        </Option>
      ))}
    </Select>
  );
};

export default StoreRequisitionNoSelect;
